<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">

    <!-- at least one true signature -->
    <h2 id="title-resume" *ngIf="hasTrueSignature">{{ 'resume.ok.text' | translate:{NB_DOCUMENTS: documents.length} }}</h2>
    <h2 id="title-resume-validation" *ngIf="!hasTrueSignature">{{ 'resume.validation.ok.text' | translate: {NB_DOCUMENTS: documents.length} }}</h2>

    <section class="infoBox">
        <p id="info-box-signed-mail" *ngIf="mail() && allSigned">{{ 'resume.infoBoxWithEmail' | translate:{NB_DOCUMENTS: documents.length} }}
            <app-wl-electronic-signature-purpose class="right"></app-wl-electronic-signature-purpose>
        </p>
        <p id="info-box-signed" *ngIf="!mail() && allSigned">{{ 'resume.infoBox' | translate: {NB_DOCUMENTS: documents.length} }}
            <app-wl-electronic-signature-purpose class="right"></app-wl-electronic-signature-purpose>
        </p>
        <p id="info-box-not-signed" *ngIf="!allSigned">{{ 'end.content.remainsSignature' | translate:{NB_DOCUMENTS: documents.length} }}
            <app-wl-electronic-signature-purpose class="right"></app-wl-electronic-signature-purpose>
        </p>
        <p id="info-box-multiple" *ngIf="documents.length >1">{{ ('end.content.summary' | signatureAction: hasTrueSignature ?
            'SIGNATURE' : 'APPROVAL') | translate:{
            NB_DOCUMENTS: documents.length
        } }}</p>
    </section>

    <section>
        <h3 id="title-signed-documents">{{ ('end.content.documents' | signatureAction: hasTrueSignature ? 'SIGNATURE' : 'APPROVAL') | translate:{NB_DOCUMENTS: documents.length} }}</h3>
        <ul class="historic content">
            <ng-container *ngFor="let document of documents; let i = index">
                <li *ngIf="document.documentName !== 'FINAL_AGREEMENT_DOCUMENT'">
                    <div>
                        <h4 id="doc-{{i}}" title="{{document.documentName}}">{{document.documentName}}</h4>
                        <dl>
                            <dt>
					<span *ngIf="document.customerSigners.length + document.prospectSigners.length != 0">
						<!-- CUSTOMERS (OTU) -->
						<span id="signed-by-{{i}}" *ngIf="document.customerSigners[0] != null"> {{'resume.documents.signedBy.label' | translate }}
                            <strong>{{ document.customerSigners[0].gender ? ('signer.gender.' + document.customerSigners[0].gender | translate) : null }}
                                {{ document.customerSigners[0].firstName }} {{ document.customerSigners[0].lastName }}</strong>
							<span [hidden]="document.customerSigners.length <= 1">
                                <ng-container *ngFor="let signer of document.customerSigners.slice(1)">
                                    {{ 'signer.and' | translate }}
                                    <strong>{{ signer.gender ? ('signer.gender.' + signer.gender | translate) : null }} {{ signer.firstName }} {{ signer.lastName }}</strong>
                                </ng-container>
                            </span>.
						</span> <!-- PROSPECTS (ORG) -->
						<span id="approved-by-{{i}}"
                              *ngIf="document.prospectSigners[0] != null"> {{ 'resume.documents.approvedBy.label' | translate }}
                            <strong>{{ document.prospectSigners[0].gender ? ('signer.gender.' + document.prospectSigners[0].gender | translate) : null }} {{ document.prospectSigners[0].firstName }}
                                {{ document.prospectSigners[0].lastName }}</strong>
							<span [hidden]="document.prospectSigners.length <= 1">
                                <ng-container *ngFor="let signer of document.prospectSigners.slice(1)">
                                    {{ 'signer.and' | translate }}
                                    <strong>{{ signer.gender ? ('signer.gender.' + signer.gender | translate) : null }} {{ signer.firstName }} {{ signer.lastName }}</strong>
                                </ng-container>

							</span>.
						</span>
						<br *ngIf="document.validators[0] != null"/>
					</span>

                                <!-- VALIDATORS (APPROVAL) -->
                                <span id="validated-by-{{i}}" *ngIf="document.validators[0] != null">
                        {{ 'resume.documents.validatedBy.label' | translate }}
                                    <strong>{{ document.validators[0].gender ? ('signer.gender.' + document.validators[0].gender | translate) : null }} {{ document.validators[0].firstName }} {{ document.validators[0].lastName }}</strong>
                        <span [hidden]="document.prospectSigners.length <= 1">
                            <ng-container *ngFor="let signer of document.validators.slice(1)">
                                {{ 'signer.and' | translate }}
                                <strong>{{ signer.gender ? ('signer.gender.' + signer.gender | translate) : null }} {{ signer.firstName }} {{ signer.lastName }}</strong>
                            </ng-container>

						</span>.
					</span>
                            </dt>
                            <dd *ngIf="document.externalDocumentStatus =='SIGNATURES_REMAINING'">
                                <ul class="k-buttons-bar">
                                    <li class="k-button ic-open" *ngIf="document.urlView" (click)="setDocumentToView(document)">
                                        <a id="link-open-{{i}}" title="{{ 'resume.documents.document.open' | translate }}"
                                           target="_blank"></a>
                                    </li>
                                </ul>
                            </dd>
                            <dd *ngIf="document.externalDocumentStatus =='SIGNED'">
                                <ul class="k-buttons-bar">
                                    <li class="k-download ic-download" *ngIf="document.urlDownload && downloadOnSummaryPage">
                                        <a (click)="downloadPdf(document)" id="link-download-{{i}}"
                                           title="{{ 'end.download' | translate }}"></a>
                                    </li>
                                    <li class="k-button ic-open" *ngIf="document.urlView" (click)="setDocumentToView(document)">
                                        <a id="link-signed-open-{{i}}" title="{{ 'resume.documents.document.open' | translate }}"
                                           target="_blank"></a>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </div>
                </li>
            </ng-container>
        </ul>
        <div *ngIf="documentToView">
            <pdf-viewer [downloadUrl]="documentToView.urlDownload" [pdfInfoUrl]="getPdfInfoUrl()" [token]="getToken()"
                        [pdfName]="documentToView.documentName"></pdf-viewer>
        </div>
    </section>

    <section class="resumeText">
        <p id="resume-text"
           [innerHTML]="('resume.content.text' | signatureAction: hasTrueSignature ? 'SIGNATURE':'APPROVAL') | translate: { NB_DOCUMENTS: documents.length }">
        </p>
    </section>
    <p *ngIf="!isSmartPhoneType" class="post-link">
        <a id="redirect-button" [hidden]="!displayRedirect()" [href]="urlOk" class="k-button ic-check">{{ 'end.redirect' | translate }}</a>
    </p>
</main>
